import React from 'react';
import SelectIndex from '../../form/selec-address/index';
import { getCities } from './data';
import model from '../../assets/model';

class City extends React.Component {
    state = {
        options: []
    }

    componentDidUpdate(prevProps) {
        const { provinceId, countryId, cascade_parent_api_name,parent_node } = this.props;
        // 当省份改变时，获取对应的城市列表
        if (provinceId && cascade_parent_api_name && provinceId[cascade_parent_api_name] && ((prevProps.provinceId == null && provinceId[cascade_parent_api_name]) || provinceId[cascade_parent_api_name] !== prevProps.provinceId[cascade_parent_api_name])) {
            getCities({ parentPath: countryId[parent_node.cascade_parent_api_name] + '/' + provinceId[cascade_parent_api_name], cardId: model.cardId }, (data) => {
                this.setState({ options: data.optionList });
            });
        }
        //国家更改，市的下拉数据要清空
        if(countryId &&  prevProps.countryId && countryId[parent_node.cascade_parent_api_name] && prevProps.countryId[parent_node.cascade_parent_api_name] && countryId[parent_node.cascade_parent_api_name] != prevProps.countryId[parent_node.cascade_parent_api_name] ){
            this.setState({ options: [] });
        }
    }
    componentDidMount() {
        //当有默认值时，需要获取市数据
        let {default_value = undefined, parent_node, api_name } = this.props
        if(parent_node && parent_node.default_value){
            getCities({ parentPath: parent_node.parent_node.default_value + '/' + parent_node.default_value, cardId: model.cardId }, (data) => {
                this.setState({ options: data.optionList });
            });
            this.props.form.setFieldsValue({
                // 使用 api_name 设置值
                [api_name]: default_value
            });
        }
    }

    render() {
        return (
            <SelectIndex 
                {...this.props} 
                options={this.state.options}
                disabled={!this.props.provinceId}
                onChange={this.props.onCityChange}
            />
        );
    }
}

export default City;


// WEBPACK FOOTER //
// ./src/component/Address/City.js